/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  addLineItems,
  checkout,
  getCart,
  getCartError,
  onBeforeCheckout,
  updateCart,
  updateLineItem,
  waitForSettle
} from '@/cart/cart-store'
import buyStack11, { BuyStack11Props } from '@/components/buy-stack/bs-11/buyStack11'
import focus from '@alpinejs/focus'
import Alpine from 'alpinejs'
import { Cart } from '@/cart/types'
import '@/components/buy-stack/TrialImageCarouselRegister'
import { effect } from '@preact/signals'

Alpine.plugin(focus)

const cartHandler: BuyStack11Props['cart'] = {
  getCart,
  getCartError,
  addLineItems,
  updateLineItem,
  checkout,
  updateCart,
  onBeforeCheckout,
  waitForSettle
}

type CartStore = {
  cart: Cart | null
  error: string | null
}

Alpine.store('cartStore', { cart: getCart() })

effect(() => {
  const cartStore = Alpine.store('cartStore') as CartStore
  cartStore.cart = getCart()
  cartStore.error = getCartError()
})

Alpine.data('buyStack11', (props: Pick<BuyStack11Props, 'step' | 'bundle' | 'bundles'>) =>
  buyStack11({ ...props, cart: cartHandler })
)

Alpine.data('quantityInput', ({ id, quantity = 0 }: { id: number; quantity?: number }) => ({
  id,
  get quantity() {
    const cart = this.$store.cartStore.cart as Cart | null

    if (!cart) return quantity

    return cart.items
      .filter(item => item.id === this.id)
      .reduce((sum, { quantity }) => sum + quantity, 0)
  }
}))

Alpine.start()
